module.exports = __webpack_public_path__ + "img/produm.92a86a0e.png";